import {
  BIN_ADD_REQUEST,
  BIN_ADD_REQUEST_SUCCESS,
  BIN_ADD_REQUEST_FAILURE,
  BIN_FETCH_REQUEST,
  BIN_FETCH_REQUEST_SUCCESS,
  BIN_FETCH_REQUEST_FAILURE,
  BIN_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const binReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case BIN_FETCH_REQUEST:
    case BIN_ADD_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case BIN_FETCH_REQUEST_SUCCESS:
    case BIN_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case BIN_FETCH_REQUEST_FAILURE:
    case BIN_ADD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case BIN_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        CRUDErrors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default binReducer;
